/*Tps-report*/
if (window.location.pathname.includes("tps-report")) {
    app.$root.drawTables();

    $(window).on('/api/note/create.success', function(e, response){
        if (typeof response['placement'] == 'undefined') return;
        var row = $(".data-table tr[data-id='"+response['placement']['id']+"']");
        var table = row.closest(".data-table");
        var data = table.DataTable().row(row).data();

        data.adjuster_update = response['placement']['adjuster_updated_at'];
        data.public_adjuster_update = response['placement']['public_adjuster_updated_at'];
        data.policyholder_update = response['placement']['policyholder_updated_at'];

        table.DataTable().row(row).data(data).draw();
    });

    const handlePolicyholderSearch = _.debounce(function () {
        const searchValue = $(this).val();
        const cards = $(".collapse .tps-report-card");

        cards.each(function () {
            const card = $(this);
            let total = 0;

            card.find(".dataTable").each(function () {
                const table = $(this);
                tableRedraw(table, searchValue);
                const info = table.DataTable().page.info();

                if (info && info.recordsDisplay) {
                    if (!searchValue && table.parents('.tps-table').hasClass('tps-table-skip-count')) {
                        total = total;
                    } else {
                        total += info.recordsDisplay;
                    }
                }
            });

            const badge = card.closest('.card').find('.badge-tps').first();

            if (total) {
                badge.text(total);
                card.closest('.card').removeClass('d-none');
                card.find(".dataTable").each(function () {
                    $(this).DataTable().columns.adjust().draw();
                });
            } else if (!total && searchValue != '') {
                card.closest('.card').addClass('d-none');
            } else {
                card.closest('.card').removeClass('d-none');
            }
        });
    }, 100);

    function tableRedraw(table, search = false) {
        const tableInstance = table.DataTable();
        if (search !== false) {
            tableInstance.columns(0).search(search).draw();
        } else {
            tableInstance.columns.adjust().draw();
        }

        const isEmpty = table.find('.dataTables_empty').length;

        isEmpty ? table.parents('.tps-table').hide() : table.parents('.tps-table').show();
    }

    $("[name='policyholder_search']").on("keyup", handlePolicyholderSearch);

    $(window).on('tableLoaded', function (event, table) {
        $("[name='policyholder_search']").trigger("keyup");
        $(table).parents('.card').removeClass('tps-loading');
    });
}



// WEBPACK FOOTER //
// ./resources/assets/js/pages/reports/tps.js